import { render, staticRenderFns } from "./UserQuestionAnswer.vue?vue&type=template&id=735b0153&scoped=true&"
import script from "./UserQuestionAnswer.vue?vue&type=script&lang=js&"
export * from "./UserQuestionAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735b0153",
  null
  
)

export default component.exports